import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/HamburgerMenu.css";

const menuItems = [
  { path: "/", label: "Home" },
  { path: "/countries", label: "Countries" },
  { path: "/about", label: "About" }
];

const HamburgerMenu = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleLinkClick = () => {
    setIsOpen(false);
    window.scrollTo(0, 0);
  };

    return (
      <header className="hamburger-menu">
        <Link to="/search" onClick={() => window.scrollTo(0, 0)} className="search-icon" aria-label="Buscar">
          <i className="fa-solid fa-magnifying-glass"></i>
        </Link>
        <div className="logo">
          <Link to="/" onClick={() => window.scrollTo(0, 0)}>
            <img src="https://meastreport.com/cms/wp-content/uploads/2025/09/logo-middle-east-report.png" alt="Logo de Middle East Report" className="logo-img"/>
          </Link>
        </div>

      <button
        className={`hamburger-button ${isOpen ? "open" : ""}`}
        onClick={toggleMenu}
        aria-label="Toggle menu"
      >
        <span className="line"></span>
        <span className="line"></span>
        <span className="line"></span>
      </button>

        <nav className="menu-desktop">
          <ul className="menu-items">
            {menuItems.map((item) => (
              <li key={item.path}>
                <Link to={item.path} onClick={() => window.scrollTo(0, 0)}>{item.label}</Link>
              </li>
            ))}
            <li className="search-item">
              <Link to="/search" onClick={() => window.scrollTo(0, 0)} aria-label="Buscar">
                <i className="fa-solid fa-magnifying-glass"></i>
              </Link>
            </li>
          </ul>
        </nav>

      <nav className={`menu-overlay ${isOpen ? "visible" : "hidden"}`}>
        <ul className="menu-items">
          {menuItems.map((item) => (
            <li key={item.path}>
              <Link to={item.path} onClick={handleLinkClick}>
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
};

export default HamburgerMenu;